<template>
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-toolbar-items>
                <v-btn flat icon @click="filterYear--">
                  <v-icon>arrow_left</v-icon>
                </v-btn>
                <v-text-field
                  prepend-icon="date_range"
                  :label="$t('year')"
                  type="number"
                  v-model="filterYear"
                  :single-line="true"
                ></v-text-field>
                <v-btn flat icon @click="filterYear++">
                  <v-icon>arrow_right</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="reviewReports"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="reviewReportsCount"
                :loading="reviewReportIsLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.rma }}</td>
                  <td>
                    <au-vehicle :vehicle="props.item.vehicle" />
                  </td>
                  <td>{{ props.item.review_date | moment("LL") }}</td>
                  <td>
                    {{ props.item.type }}
                  </td>
                  <td>
                    <action-tooltip
                      icon="details"
                      color="primary"
                      :tooltip="$t('details')"
                      :to="{
                        name: 'ReviewReportShow',
                        params: { id: props.item.id }
                      }"
                    ></action-tooltip>
                    <action-tooltip
                      icon="edit"
                      color="info"
                      :tooltip="$t('edit')"
                      :to="{
                        name: 'ReviewReportEdit',
                        params: { id: props.item.id }
                      }"
                      v-if="hasPermission(ROLE_PERMISSION_REVIEW_REPORT_EDIT)"
                    ></action-tooltip>
                    <action-tooltip
                      icon="delete"
                      color="red"
                      :tooltip="$t('delete')"
                      @click="$refs.deleteDialog.deleteAction(props.item)"
                      v-if="hasPermission(ROLE_PERMISSION_REVIEW_REPORT_DELETE)"
                    ></action-tooltip>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <delete-dialog
      messageKey="deleteReviewReport"
      itemKey="rma"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_REVIEW_REPORTS,
  DELETE_REVIEW_REPORT,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import {
  ROLE_PERMISSION_REVIEW_REPORT_EDIT,
  ROLE_PERMISSION_REVIEW_REPORT_DELETE
} from "@/common/permissions";

export default {
  data() {
    return {
      modal: {
        show: false,
        mode: ""
      },
      pagination: {
        sortBy: "review_date",
        descending: true
      },
      headers: [
        { text: this.$t("number"), value: "rma" },
        { text: this.$t("vehicle"), value: "vehicle" },
        { text: this.$t("reviewDate"), value: "reviewDate" },
        { text: this.$t("reviewType"), value: "type" },
        { text: this.$t("actions"), sortable: false }
      ],
      ROLE_PERMISSION_REVIEW_REPORT_EDIT: ROLE_PERMISSION_REVIEW_REPORT_EDIT,
      ROLE_PERMISSION_REVIEW_REPORT_DELETE: ROLE_PERMISSION_REVIEW_REPORT_DELETE,
      filterYear: new Date().getFullYear()
    };
  },
  computed: {
    ...mapGetters([
      "reviewReports",
      "reviewReportsCount",
      "reviewReport",
      "reviewReportIsLoading",
      "hasPermission"
    ]),
    createdAtFrom() {
      return this.$moment(`${this.filterYear}-01-01`, "YYYY-MM-DD").format();
    },
    createdAtTo() {
      return this.$moment(`${this.filterYear + 1}-01-01`, "YYYY-MM-DD")
        .subtract(1, "seconds")
        .format();
    }
  },
  watch: {
    filterYear: function() {
      this.fetchItems();
    }
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_REVIEW_REPORTS, [
        this.pagination,
        this.search,
        {
          "createdAt:from": this.createdAtFrom,
          "createdAt:to": this.createdAtTo
        }
      ]);
    },
    createAction() {
      this.$router.push({ name: "ReviewReportCreate" });
    },
    deleteConfirmation(reviewReport) {
      this.$store.dispatch(DELETE_REVIEW_REPORT, reviewReport.id).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("deletedSuccessfully", [this.$t("reviewReport")]),
          color: "success"
        });

        this.fetchItems();
      });
    }
  }
};
</script>

<style scoped></style>
